import { MapSearchHeader as MapSearchHeaderUI } from 'ui-components'
export const MapSearchHeader = () => {
  return <MapSearchHeaderUI />
}
